import type { OrderStatus } from "@/lib/api/types";
import { getAllowedTransitions, type OrderTransition } from "./orderStatusMachine";

/** The single forward (primary) transition for a status, if one exists. */
export function getPrimaryTransition(
  status: OrderStatus,
): OrderTransition | null {
  return getAllowedTransitions(status).find((a) => a.variant === "primary") ?? null;
}
